import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "./localStorageUtil";

const getAd = () => LocalStorageUtil.getAd() || "PurityBase";

/** 与 Cart / CheckOut 等一致：无则生成 6 位字母数字并写入 localStorage */
const generateVisitorUserId = () => {
  const ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let i = 0; i < 6; i++) r += ch[Math.floor(Math.random() * ch.length)];
  return r;
};

const ensureUserId = () => {
  if (typeof localStorage === "undefined") return "";
  let id = localStorage.getItem("userid");
  if (!id) {
    id = generateVisitorUserId();
    localStorage.setItem("userid", id);
  }
  return id;
};

/**
 * 与站内其它 sendMessage 调用一致的首行：站点 + 类型 + ad + userid
 * 正文为固定英文键名，便于后台解析与归档
 */
export const buildBulkQuoteMessage = (name, email, request) => {
  const header = `${BASE_URL} [Bulk Quote]:ad=${getAd()}:userid=${ensureUserId()}`;
  const body = [
    `Full Name:`,
    String(name ?? "").trim(),
    ``,
    `Email:`,
    String(email ?? "").trim(),
    ``,
    `Request:`,
    String(request ?? "").trim(),
    ``,
    `---`,
    `Submitted: ${new Date().toISOString()}`,
  ].join("\n");
  return `${header}\n\n${body}`;
};

export const buildPartnerApplicationMessage = (name, email, platform, message) => {
  const header = `${BASE_URL} [Partner Application]:ad=${getAd()}:userid=${ensureUserId()}`;
  const platformLine =
    (platform && String(platform).trim()) || "(not provided)";
  const body = [
    `Full Name:`,
    String(name ?? "").trim(),
    ``,
    `Email:`,
    String(email ?? "").trim(),
    ``,
    `Platform / Website:`,
    platformLine,
    ``,
    `Message:`,
    String(message ?? "").trim(),
    ``,
    `---`,
    `Submitted: ${new Date().toISOString()}`,
  ].join("\n");
  return `${header}\n\n${body}`;
};
